<template>
   <div class="ancillary-seat-map-passenger-container" @click="handlerSelectSeat" :class="{ selected: SeatSelected, active: IsPassengerSelectionActive, noPointer: IsPassengerInfant }">
      <div class="passenger-information-container">
         <div class="row">
            <div class="col">
               <!-- <span class="info-label">{{ $t("ancillarySeatMap_lblPassenger") }}</span> -->
               <span>
                  {{ passenger.paxName }}
               </span>
               <i class="txt-xsmall">({{ passenger.paxType }} )</i>
            </div>
            <div class="col">
               <!-- <span class="info-label">{{ $t("ancillarySeatMap_lblPrice") }}</span> -->

               <span>{{ passenger.price ?? "-" | price(currency) }} </span>
            </div>
            <div class="col">
               <!-- <span class="info-label">{{ $t("ancillarySeatMap_lblSeat") }}</span> -->
               <span>{{ passenger.seat }} </span>
            </div>
         </div>
      </div>

      <div class="cancel-seat-btn" :style="{ visibility: SeatSelected && !IsPassengerInfant ? '' : 'hidden' }" @click="handlerCancelSeat">
         <i class="gts-icon icon-cancel-seat-selection"></i>
      </div>
   </div>
</template>

<script>
// import UITooltip from "@/components/utils/GtsToolTips.vue";
export default {
   name: "AncillarySeatMap",
   props: {
      passenger: Object,
      currency: String,
   },
   components: {
      // UITooltip,
   },
   computed: {
      IsPassengerSelectionActive() {
         return this.passenger.selected;
      },
      IsPassengerInfant() {
         return this.passenger.paxTypeEnum == 3;
      },
      SeatSelected() {
         return this.passenger.seat != null;
      },
   },
   methods: {
      handlerSelectSeat() {
         if (!this.IsPassengerInfant) {
            this.$store.dispatch("seatmap/updatePaxSelection", this.passenger);
         }
      },

      handlerCancelSeat() {
         this.$store.commit("seatmap/cancelSeatSelection", this.passenger);
      },
   },
};
</script>

<style lang="scss" scoped>
.ancillary-seat-map-passenger-container {
   display: flex;

   padding: 0.5rem 0.75rem;
   border-radius: 0.5rem;
   margin: 1rem 0;
   width: fit-content;
   min-width: 350px;
   cursor: pointer;

   outline-color: var(--gray-200);
   outline-style: solid;

   &.selected {
      background-color: var(--cyan-0);
      outline: 1.5px solid var(--blue-100);
      color: var(--primary);
   }
   &.active {
      outline: 2.5px solid var(--accent-primary);
      color: var(--primary);
      cursor: default !important;
      /* box-shadow: var(--gray-1000-alpha-75) 0px 0px 5px 0px, var(--gray-1000-alpha-75) 0px 0px 1px 0px; */
      box-shadow: var(--gts-box-shadow);
   }
   &:hover {
      background-color: var(--green-0);
      background-color: var(--gray-200);
   }

   .passenger-information-container {
      width: 100%;

      .row {
         margin-bottom: 0.5rem;
         display: grid;
         grid-template-columns: 4fr 2fr 1.5fr 0.5fr;
         grid-gap: 0.25rem;

         &:last-child {
            margin-bottom: 0 !important;
         }
         .col {
            display: flex;
            flex-direction: column;

            span {
               white-space: nowrap;
               font-weight: 500;
               font-size: 1rem;

               &.info-label {
                  font-weight: 400;
                  font-size: 0.85rem;
                  opacity: 0.75;
               }

               i {
                  font-size: var(--xsmall);
               }
            }
         }
      }
   }
   .passenger-cta {
      display: flex;
      align-items: center;
      margin-right: 1rem;

      &.active {
         .passenger-cta-btn {
            &::after {
               background-color: var(--accent-primary);
            }
         }
      }

      .passenger-cta-btn {
         display: block;
         $size: 28px;
         width: $size;
         height: $size;
         //background-color: var(--gray-50);
         background-color: var(--gray-0);
         border: 3px solid var(--accent-primary);
         outline: 3px solid var(--blue-100);
         border-radius: 25rem;
         display: flex;
         align-items: center;
         justify-content: center;

         &::after {
            content: "";
            width: 70%;
            height: 70%;
            display: flex;
            border-radius: 50%;
         }
      }
   }
   .cancel-seat-btn {
      display: flex;
      align-items: center;

      button {
         background-color: var(--primary);

         padding: 0.65rem 1rem;
         //color: var(--gray-50);
         color: var(--gray-0);
         border-radius: 0.5rem;
         font-weight: 600;
         font-size: var(--small);
      }
   }
}
</style>
